import React, { useRef } from "react"
import { useQuerySubscription } from "react-datocms"
import { getAllRecords, getSubscription, queries } from "@data/datocms"
import { loadOptionsData } from "@data/options"
import { datoModels } from "@data/static"
import LandingPageBody from "@components/layouts/landingPage/LandingPageBody/LandingPageBody"
import LandingPageGuides from "@components/layouts/landingPage/LandingPageGuides/LandingPageGuides"
import LandingPageHeader from "@components/layouts/landingPage/LandingPageHeader/LandingPageHeader"
import LandingPagePosts from "@components/layouts/landingPage/LandingPagePosts/LandingPagePosts"
import LandingPageSuppliers from "@components/layouts/landingPage/LandingPageSuppliers/LandingPageSuppliers"
import Layout from "@components/structure/Layout/layout"
import Seo from "@components/structure/Seo/Seo"

export async function getStaticPaths() {
  const { records } = await getAllRecords(datoModels.PARTY_TYPE_PAGE, null, null, true)
  return {
    paths: records.map((partyTypePage) => `/category/${partyTypePage.slug}`),
    fallback: false,
  }
}

export async function getStaticProps({ params }) {
  const graphqlRequest = {
    query: `
      query PartyTypePageBySlug($slug: String) {
        ${queries.seo}
        partyTypePage(filter: {slug: {eq: $slug}}) {
          ${queries.innerPartyTypePage}
        }
        morePosts: allBlogs(orderBy: publishedDate_DESC, first: 3) {
         ${queries.blog.query}
        }
      }
    `,
    variables: {
      slug: params.slug,
    },
  }

  const subscription = await getSubscription(graphqlRequest)
  const options = await loadOptionsData()

  return {
    props: {
      subscription,
      options,
    },
  }
}

export default function partyTypePage({ subscription, options }) {
  const {
    data: { seo, partyTypePage, morePosts },
  } = useQuerySubscription(subscription)

  const scrollRef = useRef(null)

  return (
    <Layout options={options}>
      <Seo global={seo} meta={partyTypePage.seo} />
      <main>
        <article>
          <LandingPageHeader
            category={partyTypePage.category.originalId}
            title={partyTypePage.title}
            intro={partyTypePage.intro}
            featuredImage={partyTypePage.featuredImage}
            scrollRef={scrollRef}
            featured={"services"}
            ctaText={`Browse ${partyTypePage.shortTitle} Suppliers`}
            partyServicePages={partyTypePage.partyServicePages}
          />

          <LandingPageSuppliers
            scrollRef={scrollRef}
            category={partyTypePage.category.originalId}
            title={partyTypePage.title}
            subtitle="Our Most Popular"
            suppliers={partyTypePage.featuredSuppliers}
          />

          <LandingPageBody title={partyTypePage.bodyHeader} body={partyTypePage.content} />

          <LandingPagePosts posts={morePosts} title="Latest posts" />
          {partyTypePage.featuredGuides ? (
            <LandingPageGuides
              featuredGuide={partyTypePage.featuredGuides}
              background={partyTypePage.guidesBackground}
            />
          ) : null}
        </article>
      </main>
    </Layout>
  )
}
